import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import { Button, Col, Row } from "react-bootstrap";
import Dropdown from "../components/dropdowns/Dropdown"
import TableData from "../components/table/TableData"
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight,faMagnifyingGlass,faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import formatDatetime from "../utils/formatDateTime.js";
import {formatDate,formatDateYYYYMMDD} from "../utils/formatDate.js";
import Calendarpicker from "../components/calendars/Calendarpicker";
import { getJobApplicants } from "../api/job_app.js";
import { getJobPosition } from "../api/job_position_api";
import DownloadCSV from '../components/exportFile/DownloadCSV.js';

function JobApplicants() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);
    const [DataDropNationality, setDataDropNationality] = useState([]);
    const [inputForm, setInputForm] = useState({
        nationality: 0,
        position: 0,
    });

    function setinput(inputname, value) {
        setInputForm((prev) => {
            return {
                ...prev,
                [inputname]: value,
            };
        });
    }

    const [dataSearchJobApp, setDataSearchJobApp] = useState({
        name: "",
        startDate: "",
        endDate: "",
    });

    const [valuefromparent1, setValuefromparent1] = useState("All");
    const [valuefromparent2, setValuefromparent2] = useState("All");
    const [selectedPosition, setSelectePosition] = useState("");
    const [selectedNationality, setSelecteNationality] = useState("");
    const [dataTable, setDatatable] = useState([]);
    const [dataTableExport, setDatatableExport] = useState([]);
    const [DataDropPosition, setDataDropPosition] = useState([]);
    const [inputDateStart, setInputDateStart] = useState("");
    const [inputDateEnd, setInputDateEnd] = useState("");

    function ChangesetValueDateStart(value) {
        setInputDateStart(value);
    }
    function ChangesetValueDateEnd(value) {
        setInputDateEnd(value);
    }

    const handleNationalityChange = (value) => {
        setSelecteNationality(value);
    };

    const ChangesetValuefromparent1 = (text) =>  {
        setValuefromparent1(text);
    }

    const handlePositionChange = (value) => {
        setSelectePosition(value);
    };

    const ChangesetValuefromparent2 = (text) =>  {
        setValuefromparent2(text);
    }

    const navigate = useNavigate();
    const navigateToAddPage = () => {
        navigate("/a&eInfoJobPosition");
    };

    const getDataJobApplicants = async () => {
        try {
            const response = await getJobApplicants();
            if (response.status === 200) {
                
                // Create a set to store unique nationalities
                const nationalitySet = new Set();
                response.data.data.forEach((item, i) => {
                    nationalitySet.add(item.nationality);
                });
                
                // Convert set to array of objects
                const dataNationality = [{ value: "", text: "All" }];
                [...nationalitySet].forEach(nationality => {
                    dataNationality.push({ value: nationality, text: nationality });
                });
                
                setDataDropNationality(dataNationality);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getJobPositionDropDown = async () => {
        try {
            let dataPosition = [{ value: "", text: "All" }];
            const response = await getJobPosition();
            if (response.status === 200) {
                const activePositions = response.data.data.filter(position => position.active === 1);
                const uniquePositions = Array.from(new Set(activePositions.map(position => position.name)))
                    .map(name => {
                        return {
                            value: activePositions.find(position => position.name === name)._id,
                            text: name
                        };
                    });
                setDataDropPosition([...dataPosition, ...uniquePositions]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const headers = ['No', 'Name', 'Job Position', 'Tel', 'Email', 'Nationality', 'Create Date'];

    const dataHeader = [
        { label: "No",column:'no' , style: { width: "5%", borderLeft: "1px solid #000",borderTopLeftRadius: "10px",borderTopRightRadius: "0px",borderBottomLeftRadius: "10px"
        ,borderBottomRightRadius: "0px",position:'relative' },status: true
        },
        { label: "Name",column:'fullname' , style: { width: "10%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Job Position",column:'job.name' , style: { width: "15%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Tel",column:'tel' , style: { width: "10%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Email",column:'email' , style: { width: "15%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Create Date",column:'created_at', style: { width: "10%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Nationality",column:'nationality' , style: { width: "10%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Resume",column:'resume' , style: { width: "15%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "View",column:'action', style: { width: "5%",borderRight: "1px solid #000",borderTopRightRadius: "10px",borderTopLeftRadius: "0px",borderBottomRightRadius: "10px",borderBottomLeftRadius: "0px"
        ,position:'relative' } }
    ];
    const [tableParam, setTableParam] = useState({
        sorting:{ column: "", order: "" },
        pageNumber:1,
        dataPerPage:10,
    }); //กำหนด column เริ่มต้นในการ sort
    const [totalNumber, setTotalNumber] = useState(0)
    useEffect(()=>{
        getTableData(); // check ว่ามีการเปลี่ยนหน้าหรือ
        getTableDataExp();
    },[tableParam])

    const sortTable = (newSorting) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            sorting: newSorting,
        }));   
    };    
    const changePage = (pageNumber) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            pageNumber: pageNumber,
        }));   
      //newSorting example 1
    };
    const changeDataPerPage = (dataPerPage) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            dataPerPage: dataPerPage,
        }));   
      //newSorting example 10
    };

    async function getTableData() {
        try {
            await setLoading(true);
            const param = {
                name:dataSearchJobApp.name,
                position_id:selectedPosition,
                nationality:selectedNationality,
                start_date:inputDateStart?new Date(formatDateYYYYMMDD(inputDateStart)):'',
                end_date:inputDateEnd?new Date(formatDateYYYYMMDD(inputDateEnd)):'',
                sort_by:tableParam.sorting.column=='no'?'_id':tableParam.sorting.column,
                order_by:tableParam.sorting.order,
                page_number:tableParam.pageNumber,
                data_per_page:tableParam.dataPerPage,
                active: "1"
            }
            let response = await getJobApplicants(param);

            let tmpDataTable = [];
            setTotalNumber(response.data.meta.total)
            for (let i = 0; i < response.data.data.length; i++) {
                const ascendingNo = { data: (i + 1)+((tableParam.pageNumber-1)*tableParam.dataPerPage) };
                const descendingNo = { data: response.data.meta.total - ((tableParam.pageNumber - 1) * tableParam.dataPerPage) - i };
                let model = {
                    no: tableParam.sorting.order == 'desc'&& tableParam.sorting.column=='no' ?
                            descendingNo:ascendingNo,
                    user_id: { data: response.data.data[i]._id
                        ,isHide: true,},
                    name: { data: response.data.data[i].fullname },
                    position: { data: response.data.data[i].job.name },
                    tel: { data: response.data.data[i].phonenumber },
                    email: { data: response.data.data[i].email },
                    created_at: {
                        data: formatDatetime(response.data.data[i].created_at),
                    },
                    nationality: { data: response.data.data[i].nationality },
                    resume: { data: response.data.data[i].cv_path },
                    action: {
                        view: true,
                        create: false,
                        delete: false,
                        update: false,
                        edit: false,
                    },
                };
                
                tmpDataTable.push(model);
            }

            setDatatable(tmpDataTable);
        } catch (error) {
            console.log('err getTableData',error)
        }
        await setLoading(false);
    }

    async function getTableDataExp() {
        try {
            await setLoading(true);
            const param = {
                name:dataSearchJobApp.name,
                position_id:selectedPosition,
                nationality:selectedNationality,
                start_date:inputDateStart?new Date(formatDateYYYYMMDD(inputDateStart)):'',
                end_date:inputDateEnd?new Date(formatDateYYYYMMDD(inputDateEnd)):'',
                limit: "-1",
                sort_by:tableParam.sorting.column=='no'?'_id':tableParam.sorting.column,
                order_by:tableParam.sorting.order,
                page_number:tableParam.pageNumber,
                data_per_page:tableParam.dataPerPage,
                active: "1"
            }

            let response = await getJobApplicants(param);
            let tmpDataTableExport = [];
            setTotalNumber(response.data.meta.total)
            for (let i = 0; i < response.data.data.length; i++) {
                const ascendingNoExp = (i + 1)+((tableParam.pageNumber-1)*tableParam.dataPerPage);
                const descendingNoExp = response.data.meta.total - ((tableParam.pageNumber - 1) * tableParam.dataPerPage) - i;
                let modelExport = {
                    no: tableParam.sorting.order == 'desc'&& tableParam.sorting.column=='no' ?
                        descendingNoExp:ascendingNoExp,
                    name: response.data.data[i].fullname,
                    position: response.data.data[i].job.name,
                    tel: response.data.data[i].phonenumber,
                    email: response.data.data[i].email,
                    nationality: response.data.data[i].nationality,
                    created_at: formatDatetime(response.data.data[i].created_at),
                };
                tmpDataTableExport.push(modelExport);
            }
            setDatatableExport(tmpDataTableExport);
        } catch (error) {
            console.log('err getTableDataExp',error)
        }
        await setLoading(false);
    }

    const handleSearchBtn = async () => {
        getTableData();
        getTableDataExp();
    };

    useEffect(()=>{
        //getTableData();
        getDataJobApplicants();
        getJobPositionDropDown();
    },[])
  return (
    <>
        <style>
            {`
                .select {
                    width: 100% !important;
                    height: 42px !important;
                    border: 1px solid #D1D3D4 !important;
                    border-radius: .25rem !important;
                    padding: 10px 5px !important;
                }
                .font-size03 {
                    width: 100%;
                    position: relative;
                }
                .options-list.active {
                    width: 100% !important;
                }
                .react-datepicker-wrapper {
                    width: 100%;
                }
                td a {
                    word-break: break-all !important;
                }
                .btn-view {
                    padding-left: 30px !important;
                }
            `}
        </style>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"CAREER JOB"} />
        <Menu
            parentmenu={"infoCareerJob"}
            activemenu={"infoJobApplicants"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-careers.png" className="ic-user01 me-2" alt="" />
                                CAREER JOB<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> JOB APPLICANTS
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12} className='mt-3'>
                                <font className="font-size08 colorBlack01 fontBold d-flex align-items-center">
                                    Search
                                </font>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={4} className="d-flex align-items-center pe-0">
                                <Row className="d-flex align-items-center w-100">
                                    <Col xs={3} className='pe-0'>
                                        <label className="fontLight font-size01 colorBlack01">
                                        Nationality
                                        </label>
                                    </Col>
                                    <Col xs={9} className='pe-0'>
                                        <Dropdown
                                            options={DataDropNationality}
                                            setinput={setinput}
                                            inputname={"Nationality"}
                                            ChangesetValuefromparent={ChangesetValuefromparent1}
                                            valuefromparent={valuefromparent1}
                                            onChange={handleNationalityChange}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={4} className="d-flex align-items-center pe-0">
                                <Row className="d-flex align-items-center w-100">
                                    <Col xs={3} className='pe-0'>
                                        <label className="fontLight font-size01 colorBlack01">
                                        Position
                                        </label>
                                    </Col>
                                    <Col xs={9} className='pe-0'>
                                        <Dropdown
                                            options={DataDropPosition}
                                            setinput={setinput}
                                            inputname={"Position"}
                                            ChangesetValuefromparent={ChangesetValuefromparent2}
                                            valuefromparent={valuefromparent2}
                                            onChange={handlePositionChange}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={4}>
                                <Row className="d-flex align-items-center">
                                    <Col xs={3}>
                                        <label className="fontLight font-size01 colorBlack01">
                                        Name
                                        </label>
                                    </Col>
                                    <Col xs={9}>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="name"
                                            placeholder="name"
                                            value={dataSearchJobApp.name}
                                            onChange={(event) =>
                                                setDataSearchJobApp({
                                                ...dataSearchJobApp,
                                                name: event.target.value,
                                                })
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={4} className="d-flex align-items-center pe-0">
                                <Row className="d-flex align-items-center w-100">
                                    <Col xs={3} className='pe-0'>
                                        <label className="fontLight font-size01 colorBlack01">
                                        Start Date
                                        </label>
                                    </Col>
                                    <Col xs={9} className='pe-0'>
                                        <Calendarpicker
                                            dataDate={null}
                                            setDatePicker={setinput}
                                            inputname={"inp2"}
                                            ChangesetValueDate={ChangesetValueDateStart}
                                            inputDate={inputDateStart}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={4} className="d-flex align-items-center pe-0">
                                <Row className="d-flex align-items-center w-100">
                                    <Col xs={3} className='pe-0'>
                                        <label className="fontLight font-size01 colorBlack01">
                                        End Date
                                        </label>
                                    </Col>
                                    <Col xs={9} className='pe-0'>
                                        <Calendarpicker
                                            dataDate={null}
                                            setDatePicker={setinput}
                                            inputname={"inp3"}
                                            ChangesetValueDate={ChangesetValueDateEnd}
                                            inputDate={inputDateEnd}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={2} className="d-flex justify-content-start">
                                <Button className="btn-search"
                                    onClick={(e) => {
                                        handleSearchBtn(selectedPosition);
                                    }}
                                >
                                        
                                <FontAwesomeIcon icon={faMagnifyingGlass} className="colorBlack01 me-2"/>
                                    Search
                                </Button>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={12} className='d-flex justify-content-end'>
                                {/* <Button className="btn-create">
                                    <img src='assets/icons/ic-export.png' alt='export' className="ic-style01 me-2"/>
                                    Export
                                </Button> */}
                                <DownloadCSV data={dataTableExport} fileName="export-data-job-app" headers={headers} />
                            </Col>
                        </Row>
                        <Row>
                            <TableData
                                dataHeader={dataHeader}
                                viewUrl={"/viewJobApplicant?id="}
                                dataTable={dataTable}
                                idName={"user_id"}
                                tableParam={tableParam}
                                sortTable={sortTable}
                                changePage={changePage}
                                changeDataPerPage={changeDataPerPage}
                                totalNumber={totalNumber}
                                tablePermission={{
                                    view: true,
                                    create: false,
                                    delete: false,
                                    update: false,
                                    edit: false,
                                }}
                            />
                        </Row>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default JobApplicants;